<template>
  <main style="height:100%; display:flex; flex-direction:column">
    <!-- header -->
    <div
      class="d-flex d-block-on-movile"
      style="position:absolute; flex-direction:row; margin-top:15px; width:100%"
    >
      <img
        class="resizable-img"
        style="object-fit:contain; margin-left:20px; margin-right:20px; max-width:110px; cursor:pointer!important; z-index:2;"
        src="/logo_estado.png"
        @click="dialogAyuda = false"
      >
      <v-spacer />
      <img
        class="resizable-img"
        style="object-fit:contain; margin-left:20px; margin-right:20px; max-width:180px;"
        src="/nuevo_logo_aj.png"
      >
    </div>
    <!-- body -->
    <v-content
      v-if="!showTerminosCondiciones"
      class="responsive-ajustador-max-width"
      style="z-index:2;"
    >
      <transition name="slide-y">
        <section v-show="dialogAyuda">
          <PreguntasFrecuentes @emitCerrarPreguntasFrecuentes="dialogAyuda = false" />
        </section>
      </transition>
      <section
        v-show="!dialogAyuda"
        class="fill-height mt-2"
        style="max-width: 100%; align-items:center; display:flex;"
      >
        <v-layout
          row
          wrap
          align-center
          justify-center
        >
          <!-- Login -->
          <v-flex
            xs10
            sm6
            md6
            lg5
            xl5
          >
            <v-layout
              align-center
              justify-center
            >
              <v-flex
                xs12
                sm8
                md9
                lg8
                xl8
              >
                <v-card
                  v-if="vNavegadorCompatible"
                  class="elevation-6 pa-3"
                >
                  <v-card-text class="pa-2">
                    <div class="d-flex align-center my-2">
                      <strong
                        style="text-overflow: ellipsis;"
                        class="resizable-txt display-1"
                      >Plataforma <span class="primary--text">AJ</span> en línea</strong>
                      <v-spacer />
                      <img
                        style="object-fit:contain; max-width:100px;"
                        src="/logo-plataforma-aj-linea-color-md.png"
                      >
                    </div>
                    <v-form
                      ref="formLogin"
                      v-model="vFormLoginValido"
                      lazy-validation
                    >
                      <v-text-field
                        v-model="vUsuario.login"
                        prepend-icon="person"
                        name="login"
                        label="Usuario"
                        type="text"
                        :disabled="vRectivarCuenta"
                        :rules="[(v) => !!v || 'Campo Obligatorio' ]"
                        maxlength="20"
                        :error="!smsLogin==''"
                        @keydown.enter="VerificarLogin()"
                      />

                      <v-text-field
                        id="password"
                        v-model="vUsuario.password"
                        prepend-icon="lock"
                        name="password"
                        :label="vTextoContrasena"
                        :type="mostrarPassword ? 'text' : 'password'"
                        :append-icon="
                          mostrarPassword ? 'visibility' : 'visibility_off'
                        "
                        clearable
                        :disabled="disable"
                        :rules="[(v) => !!v || 'Campo Obligatorio']"
                        maxlength="60"
                        :error="!smsLogin==''"
                        @click:append="mostrarPassword = !mostrarPassword"
                        @keydown.enter="VerificarLogin()"
                      />
                      <CustomAlert
                        v-if="smsLogin != null && smsLogin != ''"
                        :borde="false"
                        :fondo="false"
                        type="error"
                        class="my-2"
                      >
                        <template v-slot:icon>
                          {{ $alertasMensaje.administrado.alert1.icon }}
                        </template>
                        <div v-html="smsLogin" />
                      </CustomAlert>


                      <template v-if="vRectivarCuenta">
                        <v-text-field
                          id="passwordNuevo"
                          v-model="vUsuario.newPassword"
                          prepend-icon="lock"
                          name="password"
                          label="Nueva Contraseña"
                          :type="mostrarPasswordNuevo ? 'text' : 'password'"
                          :append-icon="
                            mostrarPasswordNuevo ? 'visibility' : 'visibility_off'
                          "
                          clearable
                          :disabled="disable"
                          :rules="[(v) => !!v || 'Campo Obligatorio']"
                          maxlength="60"
                          @click:append="
                            mostrarPasswordNuevo = !mostrarPasswordNuevo
                          "
                        />

                        <v-text-field
                          id="passwordReNuevo"
                          v-model="vRepetirPasswordNuevo"
                          prepend-icon="lock"
                          name="password"
                          label="Repetir Nueva Contraseña"
                          :type="mostrarPasswordReNuevo ? 'text' : 'password'"
                          :append-icon="
                            mostrarPasswordReNuevo ? 'visibility' : 'visibility_off'
                          "
                          clearable
                          :disabled="disable"
                          :rules="[
                            (v) => !!v || 'Campo Obligatorio',
                            (v) =>
                              v == this.vUsuario.newPassword ||
                              'Las contraseñas no coinciden',
                          ]"
                          maxlength="60"
                          @click:append="
                            mostrarPasswordReNuevo = !mostrarPasswordReNuevo
                          "
                        />
                      </template>
                    </v-form>
                  </v-card-text>
                  <v-layout>
                    <v-flex />
                    <v-flex>
                      <template>
                        <!-- <vue-recaptcha
                          ref="recaptcha"
                          v-model="respuestaCaptcha"
                          class="ma-10 g-recaptcha"
                          sitekey="6LcI_mcUAAAAAAebiEZL4LhF1JcGDJqzI1kQ71b2"
                          @verify="onVerify"
                          @expired="onExpired"
                        />-->
                      </template>
                    </v-flex>

                    <v-flex />
                  </v-layout>
                  <section style="line-height: 1.5;">
                    <v-flex
                      lg8
                      offset-lg2
                      md11
                      offset-md1
                      sm10
                      offset-sm0
                      xs10
                      offset-xs0
                    >
                      <div class="body-2 text-xs-center">
                        <v-checkbox
                          v-model="checkboxTerminos"
                          color="primary"
                        >
                          <template v-slot:label>
                            <span>
                              Acepto los
                              <a @click="showTerminosCondiciones = !showTerminosCondiciones">
                                términos, condiciones y políticas de seguridad y privacidad
                              </a>
                              de las Plataforma AJ en línea (PAJEL).
                            </span>
                          </template>
                        </v-checkbox>
                      </div>
                    </v-flex>
                  </section>
                  <v-card-actions class="justify-center">
                    <br>
                    <!--<v-btn
                      round
                      color="primary"
                      :loading="vLoading"
                      :disabled="(respuestaCaptcha && checkboxTerminos) ? false : true"
                      @click="VerificarLogin()"
                    >
                      {{ vTextoBoton }}
                    </v-btn>-->
                    <v-btn
                      round
                      color="primary"
                      :loading="vLoading"
                      :disabled="!checkboxTerminos"
                      @click="VerificarLogin()"
                    >
                      {{ vTextoBoton }}
                    </v-btn>
                  </v-card-actions>
                  <br>
                  <section
                    class="text-xs-center"
                    style="line-height: 1.7;"
                  >
                    <a
                      style="text-decoration:underline;"
                      @click="vDialogReseteo = !vDialogReseteo"
                    >
                      <v-icon
                        small
                        color="primary"
                      >key</v-icon>&nbsp;¿Perdiste tu contraseña?
                    </a>
                    <br>
                    <router-link :to="{ name: 'Formulario Solicitud Credenciales' }">
                      <v-icon
                        color="primary"
                        small
                      >
                        manage_accounts
                      </v-icon> ¿No tienes cuenta? <span style="text-decoration:underline;">Solicita tus credenciales</span>
                    </router-link>
                    <br>
                    <a
                      style="text-decoration:underline;"
                      @click="dialogAyuda = !dialogAyuda"
                    >
                      <v-icon
                        color="primary"
                        small
                      >contact_support</v-icon>&nbsp;Preguntas frecuentes
                    </a>
                  </section>



                  <!--<span style="color:red">{{smsLogin}} </span>-->
                </v-card>
                <v-card v-else>
                  <!-- <v-toolbar dark color="blue">
                  <v-toolbar-title>Los navegadores soportados son Google Chrome y Mozilla Firefox.</v-toolbar-title>
                </v-toolbar> -->
                  <v-card
                    color="light-blue darken-2"
                    class="white--text"
                  >
                    <v-card-title primary-title>
                      <div>
                        <div class="headline">
                          Navegador No Soportado
                        </div>
                        <span>Se recomienda utilizar
                          <b><a
                            style="color: #ff8a65"
                            href="https://www.google.com/intl/es/chrome/"
                            target="_blank"
                          >Google Chrome</a></b>
                          o
                          <b><a
                            style="color: #ff8a65"
                            href="https://www.mozilla.org/"
                            target="_blank"
                          >Mozilla Firefox</a></b>
                          en sus últimas versiones.</span>
                      </div>
                    </v-card-title>
                  </v-card>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- Carousel -->
          <v-flex
            xs10
            sm6
            md6
            lg5
            xl5
          >
            <v-layout
              align-center
              justify-center
            >
              <v-flex
                xs12
                sm8
                md9
                lg8
                xl8
              >
                <div style="min-width: 332px;">
                  <v-hover v-slot:default="{ hover }">
                    <v-carousel
                      :height="carouselHeight"
                      :cycle="hover ? false : true"
                      style="background: rgba(0, 0, 0, 0.5)"
                      hide-delimiters
                    >
                      <v-carousel-item
                        v-for="(item,i) in result"
                        :key="i"
                      >
                        <v-img
                          contain
                          :src="`${urlDescargaAviso}/${item.nombreArchivo}`"
                          class="fill-height"
                        >
                          <v-container
                            fill-height
                            fluid
                            pa-0
                            ma-0
                          >
                            <v-layout
                              fill-height
                              align-end
                            >
                              <v-flex xs12>
                                <v-card id="create">
                                  <v-speed-dial
                                    :bottom="bottom"
                                    :right="right"
                                  >
                                    <template v-slot:activator>
                                      <v-btn
                                        color="blue"
                                        dark
                                        fab
                                        @click="show = !show"
                                      >
                                        <v-icon
                                          v-if="!show"
                                          medium
                                        >
                                          mode_comment
                                        </v-icon>
                                        <v-icon
                                          v-if="show"
                                          medium
                                        >
                                          close
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-speed-dial>
                                </v-card>
                                <v-card
                                  v-show="show"
                                  class="pa-2"
                                  style="background: rgba(0, 0, 0, 0.8); text-align: justify;"
                                >
                                  <span
                                    class="caption font-weight-black white--text"
                                    style="text-decoration: underline;"
                                    v-text="item.titulo ? item.titulo : ''"
                                  /><br>
                                  <span
                                    v-if="item.enlace"
                                    class="caption font-weight-black white--text"
                                    style="text-decoration: underline;"
                                  >
                                    <a
                                      :href="item.enlace ? item.enlace : ''"
                                      target="_blank"
                                    >{{ item.enlace }}</a>
                                  </span>
                                  <br v-if="item.enlace">
                                  <span
                                    class="caption font-weight-medium white--text"
                                  >
                                    {{ item.contenido }}
                                  </span>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-img>
                      </v-carousel-item>
                    </v-carousel>
                  </v-hover>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </section>
    </v-content>
    <v-content v-else>
      <transition
        name="slide-y"
      >
        <TerminosCondiciones
          v-show="showTerminosCondiciones"
          @emitCerrarTerminosCondiciones="showTerminosCondiciones = false"
        />
      </transition>
    </v-content>
    <!-- footer -->
    <div
      class="d-flex d-block-on-movile align-baseline"
      style="position:absolute; flex-direction:row; bottom:0; width:100%;"
    >
      <div style="margin-left:16px;margin-bottom: 4px;">
        <em class="caption">&copy; Autoridad de Fiscalización del Juego.</em><br>
        <em class="caption">Plataforma AJ en Línea v.3 - Bolivia, {{ new Date().getFullYear() }}</em>
      </div>
      <v-spacer />
      <img
        class="resizable-img"
        style="object-fit: contain;margin-bottom:15px; max-width:80px;"
        src="/logo_iso.png"
      >
    </div>

    <v-dialog
      v-model="vDialogReseteo"
      max-width="450"
      persistent
    >
      <v-card>
        <v-card-title class="primary--text">
          <h2 class="primary--text">
            <v-icon color="primary">
              key
            </v-icon>&nbsp;&nbsp;¿PERDISTE TU CONTRASEÑA?
          </h2>
          <v-spacer />
          <v-btn
            icon
            @click="vDialogReseteo = !vDialogReseteo"
          >
            <v-icon color="primary">
              close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          Por favor ingrese su <b>usuario</b>. Se enviará a su correo electrónico una <b>nueva</b> contraseña.
          <v-form
            ref="form"
            v-model="vFormValido"
            lazy-validation
          >
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-text-field
                  v-model="vUsuarioReseteo.login"
                  label="Usuario"
                  clearable
                  :rules="[(v) => !!v || 'Campo Obligatorio']"
                  :disabled="!vHabilitarBoton"
                  maxlength="20"
                />
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            round
            color="error"
            :disabled="!vHabilitarBoton"
            @click.native="vDialogReseteo = !vDialogReseteo"
          >
            <v-icon>close</v-icon>&nbsp;Cerrar
          </v-btn>
          <v-btn
            round
            color="success"
            :disabled="!vHabilitarBoton"
            @click.native="SolicitarContrasena()"
          >
            <v-icon>check</v-icon>&nbsp;Solicitar Contraseña
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogMessage"
      max-width="300"
      persistent
    >
      <v-card>
        <v-card-text>
          <div style="display:flex;align-items:center;">
            <h2 class="primary--text">
              ¿HA OLVIDADO SU CONTRASEÑA?
            </h2>
            <v-spacer />
            <v-btn
              icon
              @click="dialogMessage=false"
            >
              <v-icon
                color="primary"
                large
              >
                close
              </v-icon>
            </v-btn>
          </div>
          <br>
          {{ vMensaje }}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="primary"
            small
            @click.native="dialogMessage = !dialogMessage"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu
      :open-on-hover="true"
      offset-y
      offset-x
      right
      top
      :nudge-right="-20"
      :nudge-top="-10"
    >
      <template v-slot:activator="{ on }">
        <v-avatar
          size="60"
          color="success"
          style="position:fixed; bottom:50px; left:20px; z-index:2; cursor:pointer;"
          v-on="on"
          @click.stop="whatsappWeb()"
        >
          <IconWhatsapp
            color="white"
            :size="42"
          />
        </v-avatar>
      </template>
      <v-card color="terciary darken-1">
        <v-card-text class="pa-2 white--text caption">
          ¿Necesitas ayuda? Escríbenos ahora...
        </v-card-text>
      </v-card>
    </v-menu>
  </main>
</template>

<script>
import CustomAlert from "@/components/CustomAlert.vue";
import GlobalCardToolTip from "@/components/Global/GlobalCardToolTip.vue";
import GlobalSpanExpandible from "@/components/Global/GlobalSpanExpandible.vue";
import IconWhatsapp from "@/components/Icons/IconWhatsapp";
import TerminosCondiciones from "@/components/TerminosCondiciones";
import types from "@/store/types/Usuario";
import PreguntasFrecuentes from "@/views/PreguntasFrecuentes.vue";
import VueRecaptcha from "vue-recaptcha";
import { mapActions } from "vuex";

export default {
  components: {
    GlobalCardToolTip,
    VueRecaptcha,
    PreguntasFrecuentes,
    TerminosCondiciones,
    GlobalSpanExpandible,
    IconWhatsapp,
    CustomAlert
  },
  data() {
    return {
      vFormLoginValido: true,
      vUsuario: {
        login: null,
        password: null,
        newPassword: null,
      },
      disable: false,
      mostrarPassword: false,
      // smsLogin: 'Usuario o Contraseña incorrecto, vueva a intentarlo.',
      smsLogin: null,
      vTextoContrasena: "Contraseña",
      vTextoBoton: "Ingresar",

      // Para Reseteo de Contraseña
      vUsuarioReseteo: {
        login: null,
      },
      vDialogReseteo: false,
      vFormValido: true,
      vHabilitarBoton: true,
      vLogin: null,

      // Para Diálogo de Respuesta de Reseteo
      dialogMessage: false,
      vMensaje: null,

      // Para Reactivar la Cuenta
      vRectivarCuenta: false,

      //Contraseña Nueva
      mostrarPasswordNuevo: false,

      //Repetir Nueva Contraseña
      mostrarPasswordReNuevo: false,
      vRepetirPasswordNuevo: null,

      //Loading en el boton Ingresar
      vVerificando: false,

      //respuestaCaptcha: false,
      respuestaCaptcha: true,


      dialogAyuda: false,
      active: 1,
      vNavegadorCompatible: null,

      //contador para intentos de reseteo contraseña
      vCantidadReseteoContraseniaPermitido:3,
      vCantidadReseteoContraseniaRelizado:0,
      checkboxTerminos: false,
      vLoading: false,
      showTerminosCondiciones: false,
      result: [],
      urlDescargaAviso: process.env.VUE_APP_URL_DESCARGA_AVISO,
      show: false,
      right: true,
      bottom: true,
      messageWhatsapp: '',
      urlContactoWhatsappSoporte: `https://wa.me/${process.env.VUE_APP_NUMBER_WHATSAPP_SOPORTE}?text=`
    };
  },
  computed:{
    // eslint-disable-next-line vue/return-in-computed-property
    carouselHeight () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '582px'
        case 'sm': return '602px'
        case 'md': return '582px'
        case 'lg': return '602px'
        case 'xl': return '590px'
      }
    }
  },
  mounted() {
    this.vNavegadorCompatible =
      this.NavegadoresCompatible() == "chrome" ||
      this.NavegadoresCompatible() == "firefox"
        ? true
        : false;

    if(this.$store.state.sessionIciado){
      this.$router.push('/')
    }

    this.cargarCarousel()
  },
  methods: {
    whatsappWeb(){
      this.messageWhatsapp = `Hola, escribo para realizar la siguiente consulta:`
      window.open(this.urlContactoWhatsappSoporte + encodeURIComponent(this.messageWhatsapp), '_blank')
    },
    onVerify(response) {
      this.respuestaCaptcha = response;
    },
    onExpired() {
      this.resetRecaptcha();
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset();
      this.respuestaCaptcha = false;
    },

    VerificarLogin() {
      localStorage.removeItem("visto_imagen"); // se elimina solo cl volover a la ventana login
      this.smsLogin = "";

      if (this.$refs.formLogin.validate()) {
        if (true) {
        //if (this.respuestaCaptcha) {
          this.vLoading = true;
          if (!this.vRectivarCuenta) {
            this.Login(this.vUsuario).then((r) => {
              this.vLoading = false;
              if (r.status === 200) {
                if (r.data.message.estado === 1003) {
                  this.vRectivarCuenta = true;
                  this.vTextoContrasena = "Contraseña Actual";
                  this.vTextoBoton = "Activar Cuenta";
                  this.vUsuario.password = null;
                  this.$refs.recaptcha.reset();
                } else {
                  this.$store.commit("cargarDatosLoginSession", r.data);
                    this.RepresentanteLegal(r.data.message.personaId).then((res) => {
                      this.$store.commit("cargarDatosRepresentantesLegalSession", res.data);
                    })
                  this.$router.push("/");
                }
              } else {
                this.smsLogin = r.mensaje;
              }
            }).catch(error =>{
                this.smsLogin = error.response.data.mensaje;
                this.vLoading = false;
            })
          } else {
            this.ReactivarCuenta(this.vUsuario).then((r) => {
              if (r.status === 200) {
                this.$store.commit("cargarDatosLoginSession", r.data);
                this.$router.push("/");
              } else {
                this.smsLogin = r.message;
                this.vLoading = false;
              }
            });
          }
        } else {
          this.smsLogin = "Captcha Incorrecto";
          this.vLoading = false;

        }
      }
    },
    SolicitarContrasena() {
      if(this.vCantidadReseteoContraseniaRelizado>=this.vCantidadReseteoContraseniaPermitido){
          // si ya paso la cantidad de reseteo no hacer nada
            this.vMensaje = "La cantidad de intentos ha superado";
            this.dialogMessage = true;
          return;
      }

      this.smsLogin = "";
      if (this.$refs.form.validate()) {
        this.vHabilitarBoton = false;
        this.ResetearClave(this.vUsuarioReseteo).then((r) => {
          if (r.data && r.status === 200) {
            this.vDialogReseteo = false;
            this.vUsuarioReseteo.login = null;
            this.vMensaje = r.data.message;
            this.dialogMessage = true;
            this.vHabilitarBoton = true;
          }
          else {
            this.vMensaje = r.message;
            this.dialogMessage = true;
            this.vHabilitarBoton = true;
          }
          this.vCantidadReseteoContraseniaRelizado++;
        });
      }
    },
    NavegadoresCompatible() {
      let vNavigator = navigator.userAgent.toLowerCase();

      if (
        vNavigator.indexOf("edge") > -1 &&
        navigator.appVersion.indexOf("edge") > -1
      ) {
        return "edge";
      } else if (
        vNavigator.indexOf("opera") != -1 ||
        vNavigator.indexOf("opr") != -1
      ) {
        return "opera";
      } else if (vNavigator.indexOf("chrome") != -1) {
        return "chrome";
      } else if (vNavigator.indexOf("safari") != -1) {
        return "safari";
      } else if (vNavigator.indexOf("firefox") != -1) {
        return "firefox";
      } else if (
        vNavigator.indexOf("msie") != -1 ||
        !!document.documentMode == true
      ) {
        //IF IE > 10
        return "ie";
      } else {
        return "unknown";
      }
    },
    async cargarCarousel(){
      try {
        const res = await fetch(process.env.VUE_APP_URL_AVISOS_VIGENTES, { method: "get" });
        const data = await res.json();
        this.result = data.result.filter((value, index) => {
          if(index < 5) return value
        })
      } catch (err) {
        //console.log('err', err)
      }
    },
    ...mapActions({
      Login: types.actions.Login,
      ResetearClave: types.actions.ResetearClave,
      ReactivarCuenta: types.actions.ReactivarCuenta,
      RepresentanteLegal:types.actions.RepresentanteLegal
    }),
  },
};
</script>

<style>
.g-recaptcha {
  width: 300px;
  margin: 0 auto auto auto;
}
.slide-y-enter-active {
  transition: transform 0.3s;
}
.slide-y-enter, .slide-y-leave-to /* .slide-x-leave-active in <2.1.8 */ {
  transform: translateY(-100%);
}
@media screen and (max-width: 480px) {
  .resizable-img {
    max-width: 140px!important;
    max-height: 140px!important;
  }
  .resizable-txt {
    font-size: 1.70rem!important;
  }
}
@media (max-width: 1024px) {
  .responsive-ajustador-max-width div {
    max-width: none!important;
  }
}
/* phone */
@media (min-width: 0px) and (max-width: 719px) {
  .d-block-on-movile {
    position: inherit!important;
  }
}
/* This is for documentation purposes and will not be needed in your application */
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
  </style>
</style>
